import axios from "axios";
const endpoint = process.env.REACT_APP_BACKEND || "http://localhost:5000";

export default class userApis {
  constructor(jwt) {
    this.headers = {
      Authourization: `Bearer ${jwt}`,
    };
  }

  errorHandler(error) {
    throw (
      error?.response?.data?.message ||
      error?.response?.data?.message ||
      error?.message
    );
  }

  async login(body) {
    try {
      const response = await axios.post(endpoint + "/users/v1/login", body);
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async register(body) {
    try {
      const response = await axios.post(endpoint + "/users/v1/register", body, {
        headers: this.headers,
      });
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async getOrdersAnalytics() {
    try {
      const response = await axios.get(endpoint + "/users/v1/analytics", {
        headers: this.headers,
      });
      // return {
      //   monthlySales: [
      //     ["Farmhouse", 3000],
      //     ["Wedding Lawn", 25000],
      //   ],
      //   yearlySales: [
      //     ["Farmhouse", 3000],
      //     ["Wedding Lawn", 25000],
      //   ],
      //   totalOrders: 21,
      //   refundedOrders: 6,
      //   completedOrders: 10,
      //   totalUsers: 7,
      // };
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async getOrders() {
    try {
      const response = await axios.get(endpoint + "/users/v1/orders", {
        headers: this.headers,
      });
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async getAdminOrders() {
    try {
      const response = await axios.get(endpoint + "/users/v1/allBookings", {
        headers: this.headers,
      });
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async getAllUsers() {
    try {
      const response = await axios.get(endpoint + "/users/v1/allUser", {
        headers: this.headers,
      });
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async contactUs(body) {
    try {
      const response = await axios.post(endpoint + "/users/v1/contact", body, {
        headers: this.headers,
      });
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async getLeads() {
    try {
      const response = await axios.get(endpoint + "/users/v1/leads", {
        headers: this.headers,
      });
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async createOrder(body) {
    try {
      const response = await axios.post(endpoint + "/users/v1/orders", body, {
        headers: this.headers,
      });
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async getDateDetails(id) {
    try {
      const response = await axios.get(
        endpoint + "/users/v1/dateDetails/" + id,
        {
          headers: this.headers,
        }
      );
      return response?.data;
    } catch (error) {
      this.errorHandler(error);
    }
  }
}
